import React, { FC, useEffect } from 'react';
import { fetch10NajTop5, fetchTop5Tournaments } from '../handlers';
import { useLoadMatchtrackerTemplates } from '../../match-statistics/hooks/useLoadMatchtrackerTemplates';
import { isMobileChannel } from '../../../common/util';
import { ErrorBoundary } from '../../../common/ErrorBoundary';

const Homepage10NajTop5: FC<{ children: any }> = ({ children }) => {
    useLoadMatchtrackerTemplates(isMobileChannel());
    useEffect(() => {
        fetch10NajTop5();
        fetchTop5Tournaments();
    }, []);
    return <ErrorBoundary description="Homepage10NajTop5">{children}</ErrorBoundary>;
};

export default Homepage10NajTop5;
